<template>
    <div class="container">
        <div class="form-top">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12" style="display:flex;align-items:center;">
                    <span style="margin-right: 60px;">管理员管理</span>
                    <el-input style="width:200px;" placeholder="查找手机号" v-model="searchForm.phone"
                        class="input-with-select" @change="pageChange(1)" clearable>
                        <i class="el-icon-search el-input__icon" slot="suffix"></i>
                    </el-input>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleEditFormShow('')">新增管理员</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="form-container">
            <el-table :data="userList" style="width: 100%" size="medium" :header-cell-style="{height: '50px'}"
                :row-style="{height: '50px',padding: '5px 0'}">
                <el-table-column label="手机" prop="phone" min-width="200"></el-table-column>
                <el-table-column label="姓名" prop="name" min-width="200"></el-table-column>
                <el-table-column label="操作" width="200" v-if="user.is_admin">
                    <template slot-scope="scope">
                        <el-button-group>
                            <!-- <el-button class="operate-btn" icon="el-icon-edit">更新密码</el-button> -->
                            <el-button icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
                    @current-change="pageChange" :current-page="currentPage"></el-pagination>
            </div>
        </div>
        <el-dialog title="管理员" :visible.sync="editFormVisible" width="30%" @closed="handleEditFormClosed">
            <div class="event-dialog-content">
                <kbm-step :config="stepConfig" :current-step-index="editStep"></kbm-step>
                <el-form :model="editForm">
                    <el-form-item label="手机号" label-width="100px">
                        <el-input :disabled="editStep === 2" v-model="editForm.phone" placeholder="手机号" autocomplete="off"></el-input>
                    </el-form-item>
                     <el-form-item label="验证码" label-width="100px" v-show="editStep === 2">
                        <el-input v-model="editForm.code" placeholder="验证码" autocomplete="off" style="margin-bottom: 10px;"></el-input>
                        <el-button type="primary" size="mini" v-if="countDown">重新发送 ({{countDown}})</el-button>
                        <el-button v-else size="mini" @click="sendCode">发送验证码</el-button>
                    </el-form-item>
                    <el-form-item label="密码" label-width="100px" v-show="editStep === 2">
                        <el-input v-model="editForm.password" placeholder="密码" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="getPhoneMsg" v-if="editStep === 1"
                    :loading="btnLoading">
                    下一步
                </el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="handleSave" v-if="editStep === 2">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Core from '../../core';
import KbmStep from '@/components/kbm-step/KbmStep'
import { mapState } from 'vuex'
import * as types from '../../store/mutation-types'

export default {
    components: {
        KbmStep
    },
    props: {},
    data() {
        return {
            searchForm: {
                phone: ''
            },
            userList: [],
            currentPage: 1,
            total: 0,
            editFormVisible: false,
            editForm: {
                phone: '',
                password: '',
                code: '',
            },
            editStep: 1,
            stepConfig: ['填写手机号', '确认管理员信息'],
            btnLoading: false,

            countDown: 0
        };
    },
    computed: {
        ...mapState([
            'user',
        ]),
    },
    mounted() {
        this.getUserList()
    },
    methods: {
        sendCode() {
            let info = this.editForm
            if(!info.phone) {
                return
            }
            if (this.timeInterval) {
                this.$message.error('操作频繁,请稍后重试')
                return
            }
            this.countDown = 60
            this.timeInterval = setInterval(() => {
                this.countDown--
                if (this.countDown === 0) {
                    clearInterval(this.timeInterval)
                    this.timeInterval = ''
                }
            },1000)
            Core.Api.Common.phoneVerificationCodeSend(info.phone).then(res => {
                this.$message.success('验证码发送成功')
            })
        },
        handleSave() {
            Core.Api.User.add(
                this.editForm.phone,
                this.editForm.password,
                this.editForm.code,
            ).then((res) => {
                this.pageChange(1);
                this.handleEditFormClose();
            })
        },
        handleDelete(id) {
            this.$confirm('确定删除该管理员？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Core.Api.User.delete(id).then((res) => {
                    this.pageChange(1);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            });
        },
        handleEditFormShow(item) {
            this.editFormVisible = true;
        },
        handleEditFormClose() {
            this.editFormVisible = false;
        },
        handleEditFormClosed() {
            Core.Util.emptyObject(this.editForm);
            this.editStep = 1;
        },
        async getPhoneMsg() {
            this.btnLoading = true;
            try {
                const { user } = await Core.Api.User.getUserByPhone(this.editForm.phone);
                console.log('user', user)
                if (user) {
                    Core.Api.User.addByphone(
                        this.editForm.phone,
                    ).then((res) => {
                        this.pageChange(1);
                        this.handleEditFormClose();
                    })
                }
                this.btnLoading = false;
                this.editStep = 2;
            } catch (error) {
                console.log(error);
            } finally {
                this.btnLoading = false;
            }
        },

        getUserList() {
            Core.Api.User.list(this.currentPage, 10, this.searchForm.phone).then((res) => {
                this.total = res.count;
                this.userList = res.user_list;
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getUserList()
        },
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #f1f4f9;
    padding: 0 40px;
    @import '@/common/styles/form.scss';
}
</style>